import { getCookie } from 'stash/utils/cookies';
import {
	CLIENT_IDS,
	REDIRECT_URLS,
	SUPPORTED_PRODUCTS,
} from 'stash/constants/authParams';

export const isEmpty = (obj) => {
	return !obj || !Object.keys(obj).length;
};

const getClientVersionParam = (version) => {
	return '&client_version=' + encodeURIComponent(`web-reg/${version}`);
};

export const buildAuthRedirect = ({
	env,
	stateParam,
	codeChallenge,
	nudataQueryParams,
	stash_code,
	stash_code_v2,
	product = '',
	baseUrl,
	version,
}) => {
	const clientId = CLIENT_IDS[env];
	const redirectUrl = REDIRECT_URLS[env];
	const productName = SUPPORTED_PRODUCTS[product];
	const clientVersionParam = getClientVersionParam(version);

	const promoString = stash_code_v2
		? `&stash_code_v2=${stash_code_v2}`
		: stash_code
		? `&stash_code=r_${stash_code}`
		: ``;
	const productString = productName ? `&product=${productName}` : '';
	const utmSource = getCookie('utm_source')
		? `&utm_source=${getCookie('utm_source')}`
		: '';
	const utmMedium = getCookie('utm_medium')
		? `&utm_medium=${getCookie('utm_medium')}`
		: '';
	const utmCampaign = getCookie('utm_campaign')
		? `&utm_campaign=${getCookie('utm_campaign')}`
		: '';
	const utmContent = getCookie('utm_content')
		? `&utm_content=${getCookie('utm_content')}`
		: '';
	const utmProvider = getCookie('utm_provider')
		? `&utm_provider=${getCookie('utm_provider')}`
		: '';
	const utmString = utmSource + utmMedium + utmCampaign + utmContent + utmProvider;

	return (
		baseUrl +
		`/sign_up?client_id=${clientId}&redirect_uri=${redirectUrl}&state=${stateParam}&response_type=code&code_challenge=${codeChallenge}&code_challenge_method=S256` +
		nudataQueryParams +
		promoString +
		productString +
		utmString +
		clientVersionParam
	);
};
export const buildAuthRedirectLogin = ({
	env,
	stateParam,
	codeChallenge,
	nudataQueryParams = '',
	baseUrl,
	version,
}) => {
	const clientId = CLIENT_IDS[env];
	const redirectUrl = REDIRECT_URLS[env];
	const clientVersionParam = getClientVersionParam(version);

	return (
		baseUrl +
		`/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&state=${stateParam}&response_type=code&code_challenge=${codeChallenge}&code_challenge_method=S256` +
		nudataQueryParams +
		clientVersionParam
	);
};
